<template>
  <div class="flex h-screen">
    <div class="w-1/2 border-r-2 border-white p-10">
      <router-link to="/steps/de">
        <div class="flag">
          <img src="images/at.svg" />
        </div>
        <div class="text">
          <h1>Willkommen!</h1>
          <div>Bitte wählen Sie Ihre Sprache aus.</div>
        </div>
      </router-link>
    </div>
    <div class="w-1/2 border-l-2 border-white p-10">
      <router-link to="/steps/en">
        <div class="flag">
          <img src="images/uk.svg" />
        </div>
        <div class="text">
          <h1>Welcome!</h1>
          <div>Please select your language.</div>
        </div>
      </router-link>
    </div>
  </div>
</template>

<style scoped>
.flag {
  margin-top: 215px;
  margin-left: auto;
  margin-right: auto;
  width: 50%;
  max-width: 430px;
}

.flag img {
  width: 100%;
}

.text {
  margin-top: 20px;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
  font-size: 28px;
}

.text h1 {
  font-size: 66px;
  text-transform: uppercase;
}
</style>

<script>
export default {
  name: "Welcome",

  mounted() {
    if (global.wpfBridge) {
      global.wpfBridge.welcomeEnter();
    }
  },

  beforeDestroy() {
    if (global.wpfBridge) {
      global.wpfBridge.welcomeLeave();
    }
  }
};
</script>

